export default (params) => ({
  trigger: {
    name: 'content_blocks.comparison.show_items',
    params: params,
  },
  config: {
    schema: {
      item_ids: {
        pattern: '^[1-9][0-9]*(?:,[1-9][0-9]+)*$',
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'show_items',
      params: {
        sub_feature: null,
      },
    },
    nonInt: true,
  },
});
